import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "../../../../deploy-url";
import * as i3 from "@nebular/theme";
import * as i4 from "@ngx-translate/core";
export class TextChangeService {
    constructor(http, deployUrl, themeService, translate) {
        this.http = http;
        this.themeService = themeService;
        this.translate = translate;
        this.currentTheme = 'default';
        this.deployUrl = deployUrl;
    }
    Init() { }
    loadTexts() {
        const t = this.themeService.currentTheme || 'default';
        this.currentTheme = t.replace(/-dark$/, '');
    }
    changeText(key, variables) {
        const i18nKey = 'footer.' + key + '.' + this.currentTheme;
        let change = this.translate.instant(i18nKey);
        if (change === i18nKey) {
            change = '';
        }
        if (variables) {
            Object.keys(variables).forEach(k => {
                change = change.replace(`{${k}}`, variables[k]);
            });
        }
        return change;
    }
}
TextChangeService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function TextChangeService_Factory() { return new TextChangeService(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i2.DEPLOY_URL), i0.ɵɵinject(i3.NbThemeService), i0.ɵɵinject(i4.TranslateService)); }, token: TextChangeService, providedIn: "root" });
